import { io, Socket } from "socket.io-client";

/**
 * Base URL del API REST (Vue CLI → solo `VUE_APP_*` se compilan en el bundle).
 * Debe terminar en `/api`, igual que `apiClient`.
 */
function getApiBaseUrl(): string {
  return (process.env.VUE_APP_API_URL || "").trim();
}

export function SocketClient(namespace: string): Socket {
  const raw = getApiBaseUrl();
  if (!raw) {
    // eslint-disable-next-line no-console -- aviso explícito: sin VUE_APP_API_URL el bundle no tiene base URL
    console.error(
      "[Nova Admin] Falta VUE_APP_API_URL en .env (Vue CLI no usa VITE_*). Ejemplo:\n" +
        "  VUE_APP_API_URL=http://localhost:3000/api\n" +
        "Reinicia `npm run serve` o vuelve a compilar tras guardar.",
    );
    // Sin URL válida: no intentar conectar (evita ERR_CONNECTION_REFUSED a un puerto inventado).
    return io("http://127.0.0.1:65535", {
      path: "/socket.io/",
      autoConnect: false,
      reconnection: false,
    });
  }

  // Quitar solo el sufijo `/api` del REST base; el namespace ya incluye `/api/...` (ej. `/api/pedidos`).
  const baseUrl = raw.replace(/\/api\/?$/, "").replace(/\/+$/, "");
  const socket = io(`${baseUrl}${namespace}`, {
    // polling primero: atrás de muchos reverse proxies `websocket` solo falla hasta que está bien el proxy
    transports: ["polling", "websocket"],
    path: "/socket.io/",
    withCredentials: true,
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  // socket.on("connect", () => {
  //   console.log(`🔌 Conectado a ${namespace}:`, socket.id);
  // });

  // socket.on("connect_error", (err) => {
  //   console.error(`❌ Error conectando a ${namespace}:`, err.message);
  // });

  return socket;
}
